export const permissionEnum = {
  PurchaseRequestRead: "PurchaseRequest.Read",
  PurchaseRequestReadAll: "PurchaseRequest.ReadAll",
  PurchaseRequestAdd: "PurchaseRequest.Add",
  PurchaseRequestEdit: "PurchaseRequest.Edit",
  PurchaseRequestDelete: "PurchaseRequest.Delete",
  PurchaseOrderRead: "PurchaseOrder.Read",
  PurchaseOrderReadAll: "PurchaseOrder.ReadAll",
  PurchaseOrderAdd: "PurchaseOrder.Add",
  PurchaseOrderEdit: "PurchaseOrder.Edit",
  PurchaseOrderDelete: "PurchaseOrder.Delete",
  PRStatusAll: "PR_Status.All",
  PRStatusCreated: "PR_Status.Created",
  PRStatusApproved: "PR_Status.Approved",
  PRStatusRejected: "PR_Status.Rejected",
  PRStatusWaitingApproval: "PR_Status.WaitingApproval",
  PRStatusCancelled: "PR_Status.Cancelled",
  POStatusAll: "PO_Status.All",
  POStatusCreated: "PO_Status.Created",
  POStatusApproved: "PO_Status.Approved",
  POStatusRejected: "PO_Status.Rejected",
  POStatusWaitingApproval: "PO_Status.WaitingApproval",
  POStatusCancelled: "PO_Status.Cancelled",
  CurrencyRead: "Currency.Read",
  ReportSpend: "Report.Spend",
  CostCenterImport: "CostCenter.Import",
  CostCenterExport: "CostCenter.Export",
  BudgetTrackingRead: "BudgetTracking.Read",
  BudgetTrackingAdd: "BudgetTracking.Add",
  BudgetTrackingEdit: "BudgetTracking.Edit",
  BudgetTrackingDelete: "BudgetTracking.Delete",
  BudgetTrackingImport: "BudgetTracking.Import",
  BudgetTrackingExport: "BudgetTracking.Export",
  ProductImport: "Product.Import",
  ProductExport: "Product.Export",
  MaterialGroupImport: "ProductCatalog.Import",
  MaterialGroupExport: "ProductCatalog.Export",
  SupplierImport: "Supplier.Import",
  SupplierExport: "Supplier.Export",
  PurchaseRequestAttachments: "PurchaseRequest.Attachments",
  PurchaseOrderAttachments: "PurchaseOrder.Attachments",
  PurchaseOrderApprover: "PurchaseOrder.Approver",
  PurchaseRequestApprover: "PurchaseRequest.Approver",
  PurchaseRequestUpdateCurrencyRates: "PurchaseRequest.UpdateCurrencyRates",
  PurchaseOrderUpdateDeliveryDate: "PurchaseOrder.UpdateDeliveryDate",
  PurchaseRequestReplaceApprover: "PurchaseRequest.ReplaceApprover",
  PurchaseOrderReplaceApprover: "PurchaseOrder.ReplaceApprover",
};
